t = require('views/internal/teacup-with-helpers')('board_menu_vis')

module.exports = t.renderable ({ current, isNewBoard, canChange, mustChange,
  hasSuperAdmins, hasOrg, orgName, privateRestricted, orgRestricted,
  publicRestricted }) ->

  if mustChange && orgName
    t.p '.quiet', ->
      t.format 'illegal org visibility', { orgName }

  orgLevel = if hasSuperAdmins
    'with super admins'
  else if hasOrg
    'with organization'
  else
    'without organization'

  permissionLevels =
    'private':
      iconClass: 'icon-private'
      restricted: privateRestricted
    'org':
      iconClass: 'icon-organization'
      restricted: orgRestricted
      invalid: isNewBoard && !hasOrg
    'public':
      iconClass: 'icon-public'
      restricted: publicRestricted

  for permissionLevel, { restricted, invalid, iconClass } of permissionLevels
    t.li ->
      disabled = restricted || invalid || !canChange
      t.a '.js-select', { class: t.classify('light-hover': !disabled, 'disabled': disabled), href: '#', name: permissionLevel }, ->
        t.span '.icon-sm.vis-icon', { class: iconClass }, ->
        t.check current == permissionLevel, permissionLevel
        t.span '.sub-name', ->
          args = if orgName? then { orgName } else {}

          t.format ['permission subtext', orgLevel, permissionLevel], args

          if canChange && restricted
            t.raw ' '
            t.span '.error', ->
              if isNewBoard
                t.format ['illegal visibility', 'create']
              else
                t.format ['illegal visibility', 'change']



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_vis.coffee